<template>
    <div>
        <a-modal
            centered
            :title="record ? '客户资料' : '最近浏览的客户'"
            :visible="visible"
            :confirm-loading="submitting"
            @cancel="on_cancel"
            width="1200px"
            :after-close="after_close"
            :mask-closable="false"
            :body-style="{ padding: '12px 0' }"
        >
            <!-- 自定义底部 -->
            <template slot="footer">
                <div class="left" style="float: left;">
                    <a-button class="btn" icon="reload" @click="load" :disabled="!data_show || loading">刷新</a-button>
                </div>

                <a-button
                    v-if="tab_active === 'basic'"
                    type="primary"
                    class="btn"
                    icon="edit"
                    @click="on_update"
                    :loading="submitting_info"
                    :disabled="!data_show || loading"
                    >保存资料修改</a-button
                >

                <a-button
                    v-if="tab_active === 'expense'"
                    type="primary"
                    icon="arrow-right"
                    @click="open(`/consumption?member_id=${record.id}`)"
                    :disabled="!data_show || loading"
                    >查看或者编辑详细消费记录</a-button
                >

                <template v-if="tab_active === 'content'">
                    <a-button type="primary" icon="delete" @click="on_reset_revisit" :disabled="!data_content || loading"
                        >清空跟进记录</a-button
                    >
                </template>
            </template>

            <!-- 主体内容 -->
            <div class="main" style="display:flex" v-if="record">
                <a-tabs
                    :active-key="record.id"
                    tab-position="left"
                    :animate="false"
                    class="tab-user"
                    :tabBarGutter="4"
                    v-if="data_history.length"
                >
                    <a-tab-pane :key="item.id" v-for="item in data_history">
                        <div slot="tab" class="tab-user-info" @click="on_select_tab(item)">
                            <div class="avatar">
                                <img :src="item.avatar" :class="item.wx_unbind ? 'unbind' : ''" />
                            </div>
                            <div class="name">{{ item.name || "匿名" }}</div>
                        </div>
                    </a-tab-pane>
                </a-tabs>

                <a-row class="tab-right">
                    <a-col class="info">
                        <div class="avatar">
                            <!-- TODO:默认头像 -->
                            <img v-if="record.avatar" :src="record.avatar" :class="record.wx_unbind ? 'unbind' : ''" />
                        </div>
                        <div class="detail">
                            <div class="user">
                                <span class="name" style="margin-right:8px">{{ record.name || "匿名" }}</span>

                                <a-icon
                                    v-if="record && record.verified_at"
                                    :class="record.verified_type"
                                    class="verified"
                                    type="icon icon-renzheng"
                                ></a-icon>

                                <!-- <a-tag v-if="data_show">
                                    <template
                                        v-if="data_show.status&&data_show.status.parent"
                                    >{{data_show.status.parent.name}}</template>
                                    <a-icon type="arrow-right" />
                                    <template v-if="data_show.status">{{data_show.status.name}}</template>
                                </a-tag>-->
                                <template v-if="data_show">
                                    <!-- <a-icon
                                        v-if="data_show.wx_openid"
                                        type="icon icon-weixin"
                                        :color="data_show.wx_unbind ? '#00000080' : '#1BAD1E'"
                                        class="wx"
                                        title="已绑定微信"
                                    /> -->

                                    <!-- <a-icon v-if="data_show.logged_at" type="mobile" class="mobile" color="#1555c2" title="手机用户" /> -->
                                </template>
                            </div>
                            <div class="desc" v-if="data_show">
                                <div class="arrived">
                                    <div class="ID">ID：{{ record.id }}</div>
                                </div>

                                <div class="created">
                                    {{ data_show.user ? data_show.user.name : "【未知操作者】" }}
                                    录入于：{{ data_show.created_at ? moment(data_show.created_at * 1000).format("YYYY-MM-DD HH:mm") : "" }}
                                </div>
                            </div>
                        </div>
                        <div class="stat" v-if="data_show">
                            <a-statistic title="余额(元)" :value="data_show.balance" style="margin-right: 50px" />
                            <a-statistic title="冻结(元)" :value="data_show.balance_frozen" style="margin-right: 50px" />
                            <a-statistic title="总消费(元)" :value="data_show.expense" />
                        </div>
                    </a-col>

                    <a-col>
                        <a-tabs v-model="tab_active" :animated="false" type="card">
                            <a-tab-pane key="basic">
                                <span slot="tab">
                                    <a-icon type="icon icon-ziliaofuzhi"></a-icon>
                                    基本资料
                                </span>

                                <a-spin tip="加载中..." :spinning="loading">
                                    <template v-show="data_show">
                                        <a-form-model :model="form" ref="member-info" :rules="rules">
                                            <a-divider orientation="left">基本信息</a-divider>
                                            <a-row :gutter="24">
                                              <a-col :span="6">
                                                <a-form-model-item label="公司名称" prop="com_name">
                                                  <a-input v-model="form.com_name" placeholder="如非公司，请填写个人" />
                                                </a-form-model-item>
                                              </a-col>

                                                <a-col :span="6">
                                                    <a-form-model-item label="客户姓名" prop="name">
                                                        <a-input
                                                            placeholder="必填"
                                                            v-model="form.name"
                                                            :disabled="!!(data_show && data_show.verified_at)"
                                                        />
                                                    </a-form-model-item>
                                                </a-col>

                                                <a-col :span="6">
                                                    <a-form-model-item label="手机号码" prop="mobile">
                                                        <a-input max="11" type="number" v-model="form.mobile">
                                                            <a-icon slot="prefix" type="icon icon-shouji1" />
                                                        </a-input>
                                                    </a-form-model-item>
                                                </a-col>
                                                <a-col :span="6">
                                                    <a-form-model-item label="微信号">
                                                        <a-input v-model="form.wechat_id">
                                                            <a-icon slot="prefix" type="icon icon-we-chat-s" />
                                                        </a-input>
                                                    </a-form-model-item>
                                                </a-col>

                                                <a-col :span="6">
                                                    <a-form-model-item label="QQ">
                                                        <a-input v-model="form.qq">
                                                            <a-icon slot="prefix" type="icon icon-qq1" />
                                                        </a-input>
                                                    </a-form-model-item>
                                                </a-col>

                                                <a-col :span="6">
                                                    <a-form-model-item label="来源渠道">
                                                        <a-button @click="visible_source = true" block v-if="!form.source_id"
                                                            >点击选择</a-button
                                                        >
                                                        <template v-if="(text_source || data_show) && form.source_id">
<!--                                                            <a-button @click="visible_source = true" block type="primary" ghost>{{
                                                                text_source || data_show.source.name + "|" + (data_show.promote_source == null ? "" : data_show.promote_source.name)
                                                            }}</a-button>-->
                                                          <a-button @click="visible_source = true" block type="primary" ghost>{{
                                                              text_source || data_show.source.name
                                                            }}</a-button>
                                                        </template>
                                                        <input type="hidden" v-model="form.source_id" />
                                                    </a-form-model-item>
                                                </a-col>

                                                <a-col :span="6">
                                                    <a-form-model-item label="身份" prop="taxonomy">
                                                        <a-radio-group v-model="form.taxonomy" button-style="solid">
                                                            <a-radio-button value="2">渠道</a-radio-button>
                                                            <a-radio-button value="1">直客</a-radio-button>
                                                            <a-radio-button value="3">代理商</a-radio-button>
                                                        </a-radio-group>
                                                    </a-form-model-item>
                                                </a-col>

                                                <!--<a-col :span="6">
                                                    <a-form-model-item label="客户需求" prop="demand_type">
                                                        <a-select allow-clear mode="multiple"
                                                                  @change="on_demand_select"
                                                                  v-model="array_demand">
                                                            <a-select-option :value="0">其他</a-select-option>
                                                            <a-select-option
                                                                    v-for="item in demand_type_array"
                                                                    :key="item.value"
                                                                    :value="item.value"
                                                            >{{ item.name }}</a-select-option
                                                            >
                                                        </a-select>
                                                    </a-form-model-item>
                                                </a-col>-->

<!--                                                <a-col :span="6">
                                                    <a-form-model-item label="来源提交入口" prop="demand_type">
                                                        {{data_show.onclick_level_name}}
                                                    </a-form-model-item>
                                                </a-col>-->

                                                <a-col :span="6">
                                                    <a-form-model-item label="地区">
                                                        <a-cascader
                                                                :options="option_area"
                                                                placeholder="选择地址"
                                                                @change="on_area_select"
                                                                v-model ="array_area"
                                                        />
                                                    </a-form-model-item>
                                                </a-col>

                                                <a-col :span="12">
                                                    <a-form-model-item label="客户属性">
                                                        <a-radio-group v-model="form.member_type" button-style="solid">
                                                            <a-radio-button value="valid">有效客户</a-radio-button>
                                                            <a-radio-button value="low">低预算</a-radio-button>
                                                            <a-radio-button value="block">5次未接</a-radio-button>
                                                            <a-radio-button value="invalid">无效沟通</a-radio-button>
                                                            <a-radio-button value="trouble">捣乱</a-radio-button>
                                                            <a-radio-button value="colleagues">同行</a-radio-button>
                                                        </a-radio-group>
                                                    </a-form-model-item>
                                                </a-col>

                                                <a-col :span="12">
                                                    <a-form-model-item label="客户等级">
                                                        <a-radio-group v-model="form.level" button-style="solid">
                                                            <a-radio-button
                                                                :value="item.value"
                                                                v-for="item in level_array"
                                                                :key="item.value"
                                                            >
                                                                <a-tooltip>
                                                                    <template slot="title">
                                                                        {{ item.name }}
                                                                    </template>
                                                                    {{ item.value }}
                                                                </a-tooltip>
                                                            </a-radio-button>
                                                        </a-radio-group>
                                                    </a-form-model-item>
                                                </a-col>

                                                <a-col :span="6">
                                                    <a-form-model-item label="商标需求">
                                                        <a-button @click="visible_trademark = true" block v-if="!form.trademark_types">点击选择</a-button>
                                                        <a-button @click="visible_trademark = true" block v-else type="primary" ghost>{{ form.trademark_types }}</a-button>
                                                        <input type="hidden" v-model="form.trademark_types" />
                                                    </a-form-model-item>
                                                </a-col>

                                                <a-col :span="12">
                                                    <a-form-model-item label="信息备注">
                                                        <a-input
                                                                type="textarea"
                                                                v-model="form.remark"
                                                                :auto-size="{ minRows: 1, maxRows: 6 }"
                                                        />
                                                    </a-form-model-item>
                                                </a-col>
                                            </a-row>
                                            <a-divider orientation="left">公司/店铺信息</a-divider>

                                            <a-row :gutter="24">

                                                <a-col :span="6">
                                                    <a-form-model-item label="来源网页">
                                                        <a-input v-model="form.com_site" />
                                                    </a-form-model-item>
                                                </a-col>

                                                <a-col :span="6">
                                                    <a-form-model-item label="来源关键字">
                                                        <a-input v-model="form.shop_name" />
                                                    </a-form-model-item>
                                                </a-col>
<!--                                                <a-col :span="6">-->
<!--                                                    <a-form-model-item label="客户地址">-->
<!--                                                        <a-input v-model="form.full_address"></a-input>-->
<!--                                                    </a-form-model-item>-->
<!--                                                </a-col>-->
                                            </a-row>
                                        </a-form-model>
                                    </template>
                                </a-spin>
                            </a-tab-pane>

                            <!-- <a-tab-pane key="hospitalized">
                                <span slot="tab">
                                    <svg class="anticon ticon">
                                        <use xlink:href="#icon-shuangsechangyongtubiao-" />
                                    </svg>
                                    住院信息
                                </span>

                                <div class="content">
                                    <a-form-model>
                                        <a-form-model-item label="当前住院状态">
                                            <a-radio-group  button-style="solid">
                                                <a-radio-button value="a">未住院</a-radio-button>
                                                <a-radio-button value="b">已住院</a-radio-button>
                                            </a-radio-group>
                                        </a-form-model-item>
                                    </a-form-model>
                                </div>
                            </a-tab-pane>-->
                            <a-tab-pane key="content">
                                <span slot="tab">
                                    <a-icon type="icon icon-comment"></a-icon>
                                    跟进动态
                                </span>

                                <div class="post-content">
                                    <a-input v-model="post_content" class="input" placeholder="填写本次跟进内容..." />
                                    <a-button
                                        :disabled="!post_content"
                                        @click="on_post_content"
                                        type="primary"
                                        :loading="submitting_content"
                                        >提交</a-button
                                    >
                                </div>

                                <a-list item-layout="horizontal" :data-source="data_content" rowKey="id" class="content-list">
                                    <a-list-item slot="renderItem" slot-scope="item, index">
                                        <a-list-item-meta :description="item.content">
                                            <div slot="title">
                                                {{ item.user.name }}
                                                <span
                                                    v-html="
                                                        $options.filters['friendly'](moment(item.time * 1000).format('YYYY-MM-DD HH:mm'))
                                                    "
                                                ></span>
                                            </div>
                                            <a-avatar slot="avatar" :src="item.user.avatar" />
                                        </a-list-item-meta>
                                    </a-list-item>
                                </a-list>
                            </a-tab-pane>

                            <!-- <a-tab-pane key="other" class="other">
                                <span slot="tab">
                                    <svg class="anticon ticon">
                                        <use xlink:href="#icon-qitashoukuan" /></svg
                                    >其他
                                </span>

                                <div>
                                    <a-row :gutter="16">
                                        <a-col :span="6">
                                            <a-button icon="icon icon-weixin" @click="on_wx_bind" block
                                                >客户绑定微信{{
                                                    data_show && data_show.wx_openid && !data_show.wx_unbind ? "（已绑定）" : ""
                                                }}</a-button
                                            >
                                        </a-col>
                                    </a-row>
                                </div>
                            </a-tab-pane> -->
                        </a-tabs>
                    </a-col>
                </a-row>
            </div>

            <!-- 历史浏览的客户 -->
            <div class="main-history" v-else>
                <a-row :gutter="24" v-if="data_history.length">
                    <a-col :span="6" v-for="item in data_history" :key="item.id">
                        <a-card hoverable @click="on_select_tab(item)" size="small">
                            <a-card-meta :title="item.name || '匿名'">
                                <div slot="description" class="description">
                                    <div class="extra"></div>
                                    <!-- <div class="phone">
                                        <i class="anticon anticon-icon icon-phone"></i>
                                        {{ item.mobile }}
                                    </div> -->
                                    <div class="date">
                                        {{ item.user ? item.user.name : "无" }} •
                                        <span
                                            v-html="$options.filters['friendly'](moment(item.created_at * 1000).format('YYYY-MM-DD HH:mm'))"
                                        ></span>
                                    </div>
                                </div>

                                <a-avatar slot="avatar" :src="item.avatar" class="b-avatar" />
                            </a-card-meta>
                        </a-card>
                    </a-col>
                </a-row>
                <a-empty v-else :image="Empty.PRESENTED_IMAGE_SIMPLE" />
            </div>
        </a-modal>

        <!-- 来源渠道 -->
        <modal_source
            :visible="visible_source"
            @close="visible_source = false"
            :callback="select_callback"
            :source_id="form.source_id"
        />
<!--      <modal_source
          :visible="visible_source"
          @close="visible_source = false"
          :callback="select_callback"
          :source_id="form.source_id"
          :promote_source_id="form.promote_source_id"
      />-->
        <!-- 商标类型-->
        <modal_trademark
                :visible="visible_trademark"
                @close="visible_trademark = false"
                @change="(e) => trademark_callback(e)"
                :record="form.trademark_types"
        />
    </div>
</template>
<script>
    import moment from "moment";
    import area from "../../../mixins/area";
    // import basic_data from "../../../mixins/basic_data";
    import modal_source from "../../components/modal_source";
    import modal_trademark from "../../components/modal_trademark";

    // import modal_status from "../components/modal_status";
    // import modal_point from "../member/modal_point";

    import env from "../../../../env";
    import { Empty } from "ant-design-vue";

    let init_form = {
        name: null,
        mobile: null,
        source_id: null,
        demand_type: null,
        remark: null,
        wechat_id: null,
        qq: null,
        com_site: null,
        com_position: null,
        com_name: null,
        level: 1,
        shop_name: null,
        identity: null,
      taxonomy: "1",
        full_address: null,
        member_area: null, //用户区域
        member_type: null, //客户属性
        trademark_types: null, //商标需求类别
        promote_source_id: null, //来源id
    };
    export default {
        components: {
            modal_source,
            modal_trademark
        },
        data() {
            return {
                Empty,
                base_url: env.base_url,
                loading: true,
                loading_point: false,
                visible_point: false,
                age: null,
                option_area: area,
                submitting: false,
                submitting_content: false,
                tab_active: "basic",
                data_show: {},
                data_content: [],
                data_history: [],
                post_content: null,
                submitting_info: false,
                visible_source: false,
                text_source: undefined,
                visible_trademark: false,
                text_trademark: undefined,
                text_industry: undefined,
                form: {},
                data_point: [],
                array_area: [],
                array_demand: [],

                point_pagination: {
                    total: 0,
                    pageSize: 50,
                    current: 1,
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: (total, range) => `${range[0]}-${range[1]} , 共 ${total} 条`,
                },
                point_columns: [
                    {
                        dataIndex: "positive",
                        width: 40,
                        scopedSlots: {
                            customRender: "positive",
                        },
                    },
                    {
                        dataIndex: "amount",
                        width: 120,
                        title: "积分数量",
                    },

                    {
                        dataIndex: "name",
                        width: 200,
                        title: "积分项目",
                    },
                    {
                        dataIndex: "created_at",
                        title: "获得/扣除时间",
                        width: 200,
                        customRender: (v) => (v ? moment(v * 1000).format("YYYY-MM-DD HH:mm") : ""),
                    },
                    {
                        dataIndex: "author.name",
                        width: 150,
                        title: "操作者",
                    },
                    {
                        dataIndex: "remark",
                        title: "备注",
                    },
                ],
                rules: {
                  com_name: [
                    {
                      required: true,
                      trigger: ["change", "blur"],
                      message: "公司名称",
                    },
                  ],
                    name: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "填写客户姓名",
                        },
                    ],
                    phone: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "填写手机号码",
                        },
                    ],
                    sex: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "选择性别",
                        },
                    ],
                    source_id: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "选择来源渠道",
                        },
                    ],
                },
            };
        },
        watch: {
            record(e) {
                if (e != null) {
                    this.load(this.load_others);
                }
            },
            visible() {
                //历史查看记录
                this.$nextTick(() => {
                    this.load_history();
                });
            },
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        mounted() {
            this.load_basic_source();
        },
        computed: {
            visible() {
                return this.$store.state.customer_visible;
            },
            callback() {
                return this.$store.state.member_callback;
            },
            record: {
                get() {
                    return this.$store.state.member_record;
                },
                set(e) {
                    this.$store.commit("change_member_record", e);
                },
            },
        },
        methods: {
            moment,
            load(callback) {
                this.loading = true;
                this.$http
                    .get(`member/${this.record.id}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_show = res.data;

                            Object.keys(this.form).map((v) => {
                                if (Object.prototype.hasOwnProperty.call(res.data, v)) {
                                    if (v === "birthdate") {
                                        this.form.birthdate = res.data.birthdate ? moment(res.data.birthdate) : null;
                                    } else {
                                        this.form[v] = res.data[v];
                                    }
                                }
                            });
                            this.array_area = this.form.member_area.split('/');
                            this.array_demand = this.form.demand_type.split(',').map(Number);
                            if (callback) {
                                callback();
                            }
                        } else {
                            this.$error({ title: "失败", centered: true, content: res.message });

                            this.on_cancel();
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            load_others() {
                //加载其他数据
                this.load_content();
                // this.load_registration();
                // this.load_attachment();

                //积分
                // this.load_point();
            },
            load_history() {
                this.$http
                    .get(`member/history_browse`)
                    .then((res) => {
                        if (res.success) {
                            this.data_history = res.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
            load_content() {
                this.$http
                    .get(`member/revisit/${this.record.id}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_content = res.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
            load_point() {
                this.loading_point = true;
                this.$http
                    .get(`member/${this.record.id}/_point_record?page=${this.point_pagination.current}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_point = res.data;
                            this.point_pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading_point = false;
                    });
            },
            on_cancel() {
                this.$store.commit("change_member_visible", false);
            },
            on_post_content() {
                this.submitting_content = true;
                this.$http
                    .post(`member/revisit`, {
                        member_id: this.data_show.id,
                        content: this.post_content,
                    })
                    .then((res) => {
                        if (res.success) {
                            //this.data_content = res.data;
                            this.load_content();
                            this.post_content = null;
                        } else {
                            this.$error({ title: "失败", centered: true, content: res.message });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting_content = false;
                    });
            },
            on_update() {
                this.$refs["member-info"].validate((valid) => {
                    if (valid) {
                        this.submitting_info = true;
                        this.$http
                            .put(`member/${this.record.id}`, this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.$message.success(res.message);

                                    if (this.callback) {
                                        this.callback();
                                    }
                                } else {
                                    this.$message.error(res.message);
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                this.submitting_info = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },
            after_close() {
                if (this.$refs["member-info"]) {
                    this.$refs["member-info"].resetFields();
                }

                this.$store.commit("change_member_record", null);

                this.data_show = undefined;
                this.data_content = [];

                this.text_source = undefined;
                this.text_industry = undefined;
                this.array_area = [];
                this.array_demand = [];
                this.form = JSON.parse(JSON.stringify(init_form));
            },
            on_area_change(v) {
                this.form.province = v[0];
                this.form.city = v.length >= 2 ? v[1] : null;
                this.form.county = v.length >= 3 ? v[2] : null;
                this.form.town = v.length >= 4 ? v[3] : null;
            },
            birthdate_change(v) {
                this.age = new Date().getFullYear() - v.year() + 1;
            },
            disabled_birthdate(v) {
                return v > new Date();
            },
            on_select_tab(item) {
                this.record = item;
            },
            select_callback(source_info, promote_source_info) {
                this.$set(this.form, "source_id", source_info.id);
                // this.$set(this.form, "promote_source_id", promote_source_info.id);
                // this["text_source"] = source_info.title + "|" + promote_source_info.title;
                this["text_source"] = source_info.title;
            },
            on_wx_bind() {
                const h = this.$createElement;

                this.$http
                    .post("ext/wxmp/utility/bind_qrcode", {
                        customer_id: this.record.id,
                    })
                    .then((res) => {
                        if (res.success) {
                            this.$info({
                                title: "引导客户微信扫码绑定",
                                centered: false,
                                content: h("div", {}, [
                                    h("p", "请将该二维码发送给客户，扫码后立即绑定账户，有效期一个小时。"),
                                    h("img", {
                                        attrs: {
                                            src: `${this.base_url}service/qrcode?str=${res.data.url}`,
                                        },
                                    }),
                                ]),
                                onOk() {},
                            });
                        } else {
                            this.$error({
                                title: "失败",
                                content: res.message,
                                centered: true,
                            });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        //this.submitting_info = false;
                    });
            },
            on_point_pagination_change(e) {
                this.point_pagination.current = e.current;
                this.load_point();
            },
            on_reset_revisit() {
                this.$confirm({
                    centered: true,
                    title: `是否清空该客户的跟进记录`,
                    content: `请注意，该操作不可恢复`,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            this.$http
                                .post("member/revisit/reset", { member_id: this.data_show.id })
                                .then((res) => {
                                    if (res.success) {
                                        this.load_content();
                                    } else {
                                        this.$error({
                                            title: "失败",
                                            centered: true,
                                            content: res.message,
                                        });
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        });
                    },
                });
            },
            trademark_callback(e) {
                let ids = ''
                e.forEach((source) => {
                    ids += source.value + ','
                })
                ids = ids.substring(0,ids.length - 1)
                this.$set(this.form, "trademark_types", ids);
                this["text_trademark"] = ids;
            },
            on_area_select(value){
                this.form.member_area = value.join("/")
            },
            on_demand_select(value){
                this.form.demand_type = value.join(",")
            }
        },
    };
</script>

<style lang="less" scoped>
    .ant-list-item-meta-description {
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-list-item-meta-title {
        color: rgba(0, 0, 0, 0.45);
    }
    .main-history {
        padding: 16px;
        .ant-card {
            margin-bottom: 16px;
            .description {
                font-size: 12px;
                .extra {
                    margin-bottom: 4px;
                    .zy {
                        background: #ffc53d;
                        padding: 0.2em 0.4em;
                        border-radius: 3px;
                        font-size: 0.9em;
                        border: 1px solid #faad14;
                        color: #111;
                        margin-right: 4px;
                        display: inline-block;
                    }
                    &.disabled {
                        cursor: not-allowed;
                    }

                    .status {
                        background: #f2f2f4;
                        padding: 0.2em 0.4em;
                        border-radius: 3px;
                        font-size: 0.9em;
                        border: 1px solid #eee;
                        color: #111;
                        display: inline-block;
                        & .none {
                            background: #9e9e9e00;
                        }
                    }
                }
                .mobile {
                    margin-bottom: 4px;
                }
            }
        }
    }
    .main {
        display: flex;
        max-height: 720px;
        min-height: 400px;
        h2 {
            margin-top: 24px;
            margin-bottom: 12px;
            &:first-child {
                margin-top: 12px;
            }
        }
        .tab-user {
            /deep/ .ant-tabs-tab {
            }
            /deep/.ant-tabs-content {
                padding: 0 !important;
            }
            .tab-user-info {
                text-align: left;
                max-width: 110px;
                overflow: hidden;
                display: flex;
                align-items: center;
                .avatar {
                    width: 26px;
                    height: 26px;
                    border-radius: 50%;
                    margin-right: 8px;
                    overflow: hidden;

                    img {
                        width: 100%;
                        &.unbind {
                            filter: grayscale(1);
                        }
                    }
                    &.female {
                        border: 1px solid #ff7878;
                    }
                    &.male {
                        border: 1px solid #3688ff;
                    }
                }
                .name {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    flex: 1;
                }
            }
        }
        .tab-right {
            width: 0;
            flex: 1;
            overflow-y: auto;
            padding-right: 24px;
            padding-left: 24px;

            .content-list {
                min-height: 200px;
                margin-bottom: 40px;
                max-height: 600px;
            }
            .post-content {
                display: flex;
                // position: absolute;
                // bottom: 0;
                // left: 0;
                // right: 0;
                margin-bottom: 12px;
                .input {
                    margin-right: 8px;
                }
            }
            .info {
                display: flex;
                // align-items: center;
                margin-bottom: 16px;
                .avatar {
                    margin-right: 12px;
                    align-self: normal;
                    width: 46px;
                    height: 46px;
                    border-radius: 50%;
                    overflow: hidden;
                    &.female {
                        border: 2px solid #ff7878;
                    }
                    &.male {
                        border: 2px solid #3688ff;
                    }
                    img {
                        width: 100%;
                        &.unbind {
                            filter: grayscale(1);
                        }
                    }
                }
                .detail {
                    flex: 1;
                    margin-right: 24px;
                    border-right: 1px solid #f0f0f0;
                    padding-right: 24px;
                    .user {
                        font-size: 18px;
                        margin-bottom: 2px;
                        display: flex;
                        align-items: center;
                        .name {
                            font-weight: bold;
                        }

                        .wx {
                            margin-left: 12px;
                            color: #1bad1e;
                        }
                    }
                    .desc {
                        font-size: 12px;
                        display: flex;
                        justify-content: space-between;
                        .arrived {
                            display: flex;
                            div {
                                margin-right: 16px;
                            }
                        }
                    }
                }
                .stat {
                    display: flex;
                }
            }
            .photo {
                .description {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
            .attachment {
                margin-top: 12px;
                /deep/ .ant-card-cover {
                    max-height: 100px;
                    overflow: hidden;
                }
                .card {
                    margin-bottom: 12px;
                }
            }
        }

        .ticon {
            width: 16px;
            height: 16px;
        }
    }
</style>
